import * as io from 'io-ts';
import { Money } from './Money';

const VirtualCardSettings = io.type({
  enabled: io.boolean,
  provider: io.string,
});
export const Capabilities = io.type({
  downPayment: io.type({
    installments: io.boolean,
  }),
});

export type VirtualCardSettings = io.TypeOf<typeof VirtualCardSettings>;

export const MerchantProgramValues = io.type({
  id: io.string,
  merchantID: io.string,
  programID: io.string,
  defaultOTPMethod: io.string,
  defaultCartAmount: Money,
  policies: io.union([
    io.undefined,
    io.type({
      virtualCardSettings: io.union([io.undefined, VirtualCardSettings]),
    }),
  ]),
  createdAt: io.string,
  capabilities: Capabilities,
  derivedCapabilities: Capabilities,
  // Probably not relevant for us?
  deletedAt: io.union([io.string, io.null]),
});

export type MerchantProgramValues = io.TypeOf<typeof MerchantProgramValues>;

export const MerchantProgramValuesResponse = io.type({
  items: io.array(MerchantProgramValues),
  pagination: io.type({
    limit: io.number,
    offset: io.number,
    total: io.number,
  }),
});

export type MerchantProgramValuesResponse = io.TypeOf<
  typeof MerchantProgramValuesResponse
>;
